import React, {Component} from "react";
import {connect} from "react-redux";
import OpenModule from "./OpenModule.js";
import applogic from "../applogic.js";
import SearchInput, {createFilter} from 'react-search-input'

class OpenList extends Component {
    componentDidMount() {
        window.$(this.opentitle).click(applogic.handleOpenListClick.bind(null, this.opentitle));
        window.$('#search-input').click(applogic.handleSearchBoxClick.bind(null, this.openlist));
        window.$('#search-clear').click(function(e){
            window.$('#search-input').val('');
            applogic.handleSearchTerm('');
        });
    }
    render() {
        let classes = 'collapse ' + (this.props.collapse['openlist'] ? 'show' : '');
        const openListDom = this.props.open.map((m, idx) => (
            <OpenModule mod={m} key={idx} collapseId={'open_' + m.ID}/>
        )).sort((a, b) => OpenModule.compare(a, b));
        let resultDom = openListDom.filter(createFilter(this.props.searchTerm, ['props.mod.CourseAcadYear', 'props.mod.CourseCode', 'props.mod.CourseName', 'props.mod.CourseSemester']));
        if (resultDom.length === 0) {
            resultDom = <div>No results found</div>;
        }
        return (
            <div className="open-list-container container">
                <div className="card">
                    <div className="open-title-container row">
                        <div className="col-8" ref={opentitle => this.opentitle = opentitle} >
                            <a data-toggle="collapse" id="open-title" href="#openlist" aria-controls="openlist" aria-expanded="false">
                                <h2 className="open-list-title">Open Weblectures</h2>
                            </a>
                        </div>
                        <SearchInput type="search" value={this.props.searchTerm} className="search-input col-4" inputClassName="form-control" id="search-input" onChange={applogic.handleSearchTerm} />
                        <i className="fa fa-times search-clear" id="search-clear" aria-hidden="true"/>
                    </div>
                    <div id="openlist" className={classes} ref={openlist => this.openlist = openlist}>
                        <div className="card-block">
                            {resultDom}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
let mapStateToProps = (state) => {
    return {
        open: state.open,
        collapse: state.collapse,
        searchTerm: state.searchTerm
    };
};
export default connect(mapStateToProps)(OpenList);


// WEBPACK FOOTER //
// ./src/componentsBody/OpenList.js